<template>
  <div id="main">
    <div id="leftSection">
      <img class="intelligo" src="../assets/Intelligo.png">
      <img class="leftImg" src="../assets/leftImgLogin.png">
    </div>
    <div id="rightSection">
      <div id="header">
        <h1>Selamat Datang!!</h1>
        <h2>Mari mulai belajar di Intelligo.id</h2>
      </div>
      <div id="form">
        <div id="leftForm">
          <h3>Email</h3>
          <input type="text" />
          <h3>Password</h3>
          <input type="password" />
        </div>
      </div>
      <div id="check">
        <input type="checkbox" />
        <p>Simpan Akun</p>
      </div>
      <button id="createAccount" value="createAccount">Login</button>
      <div id="loginGoogle">
        <img src="../assets/logoGoogle.png" />
        <p>Masuk dengan Google</p>
      </div>
      <div id="login">
        <p>Belum punya akun?</p>
        <a href="#">Registrasi</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: `LoginComp`,
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap");
#main {
  margin: 0 auto;
  height: 982px;
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  font-family: "Poppins", sans-serif;
  color: black;
}
#leftSection {
  flex: 50%;
  /* background-color: #023047; */
}
#leftSection .intelligo {
    position: absolute;
    margin-top: 35px;
    margin-left: 100px;
}
#leftSection .leftImg {
    width: 600px;
    height: 764px;
    object-fit: cover;
}
#rightSection {
  flex: 50%;
  margin-top: 100px;
  margin-left: 20px;
}
#rightSection #header {
  margin-left: 90px;
  margin-top: 120px;
}
#header h1 {
  font-size: 32px;
  font-weight: 600;
}
#header h2 {
  font-size: 16px;
  font-weight: 400;
  color: #78839e;
  margin-top: 5px;
  margin-bottom: 5px;
}
#rightSection #form {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  margin-left: 90px;
}
#form h3 {
  margin-top: 30px;
  font-size: 14px;
  font-weight: 400;
}
#form input {
  border-radius: 10px;
  width: 400px;
  height: 40px;
  margin-top: 8px;
  padding: 12px 17px;
}
#form #rightForm {
  margin-left: 20px;
}
#check {
  display: flex;
  flex-direction: row;
  margin-left: 90px;
}
#check p {
  font-size: 12px;
  font-weight: 400;
  margin-left: 10px;
}
#check input {
  width: 18px;
  height: 18px;
  border-radius: 5px;
}
#rightSection button {
  margin-left: 90px;
  margin-top: 10px;
  width: 400px;
  height: 50px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  border: 1px solid #023047;
  background-color: #023047;
  border-radius: 8px;
}
#rightSection #loginGoogle {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  width: 400px;
  height: 50px;
  font-size: 16px;
  font-weight: 500;
  align-items: center;
  padding: 12px 3px 12px 95px;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  cursor: pointer;
  margin-left: 90px;
}
#loginGoogle p {
  padding-top: 17px;
  margin-left: 14px;
}
#rightSection #login {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  margin-left: 180px;
}
#login a {
  margin-left: 5px;
  color: #f74d00;
}

@media only screen and (max-width: 500px) {
  #main {
    height: 175px;
  }
  #leftSection {
    flex: 10%;
  }
  #leftSection .intelligo {
    width: 35px;
    height: 7px;
    margin-top: 10px;
    margin-left: 3px;
  }
  #leftSection .leftImg{
    width: 137px;
    height: 175px;
  }
  #rightSection {
    width: 50%;
    margin-top: 10px;
    margin-left: 10px;
  }
  #rightSection #header {
    margin-top: 5px;
    margin-left: 0;
  }
  #header h1 {
    margin-bottom: 0;
    text-align: center;
    width: 100%;
    font-size: 6px;
  }
  #header h2 {
    margin-top: 3px;
    text-align: center;
    font-size: 5px;
    width: 100%;
  }
  #rightSection #form {
    margin-left: 20%;
  }
  #form h3 {
    margin-top: 3px;
    margin-bottom: -3%;
    font-size: 4px;
    height: 0px;
  }
  #form input {
    border-radius: 5px;
    width: 100%;
    height: 5px;
    margin-top: 0px;
    padding: 3px;
    font-size: 3px;
  }
  #form #leftForm {
    width: 75%;
    margin-bottom: -3%;
  }
  #check {
    height: 10px;
    margin-left: 20%;
  }
  #check input {
    width: 7px;
    height: 7px;
  }
  #check p {
    font-size: 4px;
    margin-left: 3px;
    margin-bottom: 0%;
  }
  #rightSection button {
    margin-top: 0%;
    margin-bottom: 0%;
    margin-left: 20%;
    width: 50%;
    height: 7%;
    font-size: 6px;
    border: 0px solid #023047;
    border-radius: 3px;
  }
  #rightSection #loginGoogle {
    margin-top: 0;
    margin-left: 20%;
    width: 50%;
    height: 7%;
    padding: 3px;
    border-radius: 3px;
  }
  #rightSection #loginGoogle img {
    width: 5px;
    height: 5px;
  }
  #rightSection #loginGoogle p {
    font-size: 5px;
    padding-top: 0;
    margin-left: 3px;
    margin-bottom: 0;
  }
  #rightSection #login {
    margin-left: 20%;
  }
  #login p , a {
    font-size: 5px;
    margin-top: -5%;
  }
}
</style>